export function PhoneIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.14.94.38 1.88.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.93.32 1.87.56 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

export function WhatsAppIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M12.04 2.5a9.35 9.35 0 0 0-8.06 14.08L3 21.5l5.05-1.32A9.33 9.33 0 1 0 12.04 2.5Zm0 1.7a7.64 7.64 0 0 1 6.48 11.69 7.64 7.64 0 0 1-9.95 2.67l-.36-.18-2.99.78.8-2.91-.2-.38A7.64 7.64 0 0 1 12.04 4.2Zm-3.2 3.95c-.17 0-.43.06-.66.31-.22.25-.86.84-.86 2.05 0 1.2.88 2.37 1 2.53.12.17 1.7 2.72 4.2 3.7 2.08.82 2.5.66 2.95.62.45-.04 1.44-.59 1.65-1.16.2-.57.2-1.06.14-1.16-.06-.1-.22-.17-.47-.3-.25-.12-1.44-.71-1.66-.79-.22-.08-.38-.12-.54.12-.16.25-.62.79-.76.95-.14.17-.28.18-.52.06-.25-.12-1.04-.38-1.98-1.21-.73-.65-1.22-1.46-1.36-1.7-.14-.25-.02-.38.1-.5.11-.11.25-.28.37-.42.12-.14.16-.25.25-.42.08-.17.04-.31-.02-.43-.06-.12-.54-1.3-.74-1.78-.2-.47-.4-.4-.54-.41h-.51Z" />
    </svg>
  );
}
